import React, { useEffect, useState } from 'react';

import { Modal } from 'antd';
import styled from 'styled-components';

import CompaniesCreateEditModalContent from './CompaniesCreateEditModalContent';
import { CompaniesCreateEditModalContext } from './CompaniesCreateEditModalContext';
import CompaniesCreateEditModalFooter from './CompaniesCreateEditModalFooter';
import { COMPANY_INITIAL_VALUES } from './constants';
import { CompanyListItemType } from '../table/types';

const StyledModal = styled(Modal)`
  &&& {
    .ant-modal-content {
      padding: 0px;
      line-height: 1;
      border-radius: 1px;
      user-select: none;
    }
    .ant-modal-body {
      padding: 0px;
    }
  }
`;

const Header = styled.div`
  padding: 16px 30px;
  font-size: 20px;
  font-family: var(--font-bold);
  border-bottom: 1px solid var(--line-gray);
`;

interface Props {
  open: boolean;
  handleClose: () => void;
  editCompany?: CompanyListItemType;
  onSubmit: (item: CompanyListItemType) => Promise<void>;
  title: string;
}

const CompaniesCreateEditModal = ({ open, editCompany, handleClose, onSubmit, title }: Props) => {
  const [company, setCompany] = useState<CompanyListItemType>(COMPANY_INITIAL_VALUES);

  const handleChange = (key: keyof CompanyListItemType, value: any) => {
    setCompany((prevCompany) => ({
      ...prevCompany,
      [key]: value,
    }));
  };

  const handleSave = async () => {
    try {
      await onSubmit(company);
      onClose();
    } catch (error) {
      console.error('Failed to submit company modal.', error);
    }
  };

  const onClose = () => {
    setCompany(COMPANY_INITIAL_VALUES);
    handleClose();
  };

  useEffect(() => {
    if (open) {
      setCompany({
        ...COMPANY_INITIAL_VALUES,
        ...editCompany,
        primary_user_id: editCompany?.primary_user?.id ?? editCompany?.primary_user_id ?? null,

        mystery_shop_setting: {
          ...COMPANY_INITIAL_VALUES.mystery_shop_setting,
          ...(editCompany?.mystery_shop_setting || {}),
        },

        shop_requests: [...COMPANY_INITIAL_VALUES.shop_requests, ...(editCompany?.shop_requests || [])],
      });
    }
  }, [open, editCompany]);

  return (
    <StyledModal open={open} width="fit-content" footer={null} onCancel={onClose}>
      <CompaniesCreateEditModalContext.Provider
        value={{
          company,
          handleChange,
          handleSave,
          onClose,
        }}
      >
        <Header>{title}</Header>
        <CompaniesCreateEditModalContent />
        <CompaniesCreateEditModalFooter />
      </CompaniesCreateEditModalContext.Provider>
    </StyledModal>
  );
};

export default CompaniesCreateEditModal;
